import { MetricName, Metrics, MetricTypeDict } from '../store/store.types'

export const getMetric = <MetricType extends MetricName>(
  metricType: MetricType
) => (metrics: Metrics): MetricTypeDict[MetricType] | undefined =>
  metrics.find((m) => m.schemaType === metricType) as
    | MetricTypeDict[MetricType]
    | undefined

export const getAnnotationsPerClassMetric = getMetric<'annotations_per_class'>(
  'annotations_per_class'
)

export const getConfusionMatrixMetric = getMetric<'confusion_matrix'>(
  'confusion_matrix'
)

export const getOverlappingScoresMetric = getMetric<'overlapping_scores'>(
  'overlapping_scores'
)
